export default __webpack_public_path__ + "static/media/refreshIcon.decd86eb.svg";